module.exports = __webpack_public_path__ + "assets/img/5c10-ne.svg";